import { layoutVersion } from './constants';
import type { TradeLayoutState } from './types';

function isValidLayoutItem(item: unknown): boolean {
  if (!item || typeof item !== 'object') return false;
  const obj = item as Record<string, unknown>;
  return (
    typeof obj.i === 'string' &&
    typeof obj.x === 'number' &&
    typeof obj.y === 'number' &&
    typeof obj.w === 'number' &&
    typeof obj.h === 'number'
  );
}

export function isValidLayoutState(value: unknown): value is TradeLayoutState {
  if (!value || typeof value !== 'object') return false;

  const obj = value as Record<string, unknown>;
  if (typeof obj.version !== 'number') return false;
  if (!Array.isArray(obj.layouts)) return false;
  if (!Array.isArray(obj.hiddenPanels)) return false;

  for (const item of obj.layouts) {
    if (!isValidLayoutItem(item)) return false;
  }

  return true;
}

/**
 * Validate and return a layout state from a value retrieved via getLocalStorage.
 * getLocalStorage already JSON-parses the stored value, so this receives the parsed object.
 */
export function loadLayout(raw: unknown): TradeLayoutState | null {
  if (!raw) return null;
  if (!isValidLayoutState(raw)) return null;
  if (raw.version !== layoutVersion) return null;
  return raw;
}
